export default __webpack_public_path__ + "static/media/ranes13.1df5f80c.jpg";